import { render, staticRenderFns } from "./AccessLayout.vue?vue&type=template&id=5a44a4e5&scoped=true&"
import script from "./AccessLayout.vue?vue&type=script&lang=js&"
export * from "./AccessLayout.vue?vue&type=script&lang=js&"
import style0 from "./AccessLayout.vue?vue&type=style&index=0&id=5a44a4e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a44a4e5",
  null
  
)

export default component.exports